import { createBrowserRouter } from 'react-router-dom';
import LoadingScreen from '../components/loading-screen';
import NotFound from '../components/not-found';
import ErrorPage from '../components/error-screen';
import {
  EmployeeSearchPage,
  HomePage,
  LoginPage,
  EcardDownload,
  OtpPage,
  Claims,
  MISReports,
  PowerBIReportPage,
  ForgotPassword,
  ResetPassword
} from './lazy-loaded-pages';
import ProtectedRoute from '../components/protected-route';
import GuestRoutes from '../components/guest-route';
import ROUTES from './constants';
import Sso from '../components/sso';

const BASE_PATH = import.meta.env.VITE_BASE_URL || '/';

/*
 *   ============================================================
 *
 *   Add all routes to ROUTES constant for ease of access.
 *
 *   ============================================================
 */

export const router = createBrowserRouter(
  [
    {
      path: '',
      element: <ProtectedRoute />,
      errorElement: <ErrorPage />,
      hydrateFallbackElement: <LoadingScreen />,
      children: [
        {
          index: true,
          element: <HomePage />,
        },
        { path: 'employee-search', element: <EmployeeSearchPage /> },
        {
          path: 'mis-reports',
          element: <MISReports />,
        },
        {
          path: ROUTES.CLAIMS,
          element: <Claims />,
        },
        {
          path: 'download-ecard',
          element: <EcardDownload />,
        },
        {
          path: 'utilisation-trends',
          element: <PowerBIReportPage />,
        },
        {
          path: 'special-mis',
          element: <PowerBIReportPage />,
        },
        {
          path: '*',
          element: <NotFound />,
        },
      ],
    },
    {
      element: <GuestRoutes />,
      path: '/',
      hydrateFallbackElement: <LoadingScreen />,
      children: [
        {
          path: 'login',
          element: <LoginPage />,
        },
        {
          path: 'otp-page',
          element: <OtpPage title="Verification" showResend={true} />,
        },
        {
          path: 'forgot-password',
          element: <ForgotPassword />,
        },
        {
          path: 'forgot-password-otp',
          element: <OtpPage title="Reset Password" showResend={false} />,
        },
        {
          path: 'forgot-password-complete',
          element: <ResetPassword />,
        },
        {
          path: 'sso',
          element: <Sso />,
        },
      ],
    },

    {
      path: '*',
      element: <NotFound />,
    },
  ],
  { basename: BASE_PATH },
);
